import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[560px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20Chinese%20cultural%20landscape%20with%20soft%20golden%20light%20rays%20streaming%20through%20elegant%20silk%20curtains%2C%20dreamy%20atmospheric%20cinematic%20style%2C%20warm%20amber%20and%20coral%20toned%20composition%2C%20minimalist%20aesthetic%20with%20rich%20textures%2C%20sophisticated%20art%20direction&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="国产久久久 - 精选内容平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
          <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
          <span className="text-sm text-background-50 font-medium">每日更新 200+ 优质内容</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
          精选国产内容
          <br />
          <span className="text-primary-400">长效稳定聚合</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          {siteInfo.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/latest"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始浏览
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12">
          {[
            { value: siteInfo.stats.totalContent, label: '精选内容' },
            { value: siteInfo.stats.dailyUpdates, label: '每日更新' },
            { value: siteInfo.stats.activeUsers, label: '活跃用户' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}